import React from 'react';
import { styled } from '@mui/material/styles';
import { AppBar } from '@mui/material';
import clsx from 'clsx';
import { REDUCED_CONTENT_MAX_WIDTH } from 'config/constants';

const PREFIX = 'FlatAppbar-';

const classes = {
    appBar: `${PREFIX}appBar`,
    marginBlock: `${PREFIX}marginBlock`,
    dense: `${PREFIX}dense`,
    small: `${PREFIX}small`,
    large: `${PREFIX}large`
};

const Root = styled('div')(({ theme }) => ({
    '--Paper-shadow': 'none',
    [`& .${classes.appBar}`]: {
        backgroundColor: theme.palette.background.default,
        color: theme.palette.primary.main,
        padding: theme.spacing(1, 2, 0, 2),
        left: '50%',
        transform: 'translateX(-50%)',
        width: '100%',
        maxWidth: REDUCED_CONTENT_MAX_WIDTH
    },

    [`& .${classes.marginBlock}`]: {
        height: '128px',
        flexShrink: 0,
        width: '100%',
        '--Paper-shadow': 'none'
    },

    [`& .${classes.dense}`]: {
        height: '48px'
    },

    [`& .${classes.small}`]: {
        height: '72px'
    },

    [`& .${classes.large}`]: {
        height: '168px'
    }
}));

interface FlatAppbarProps extends React.PropsWithChildren {
    variant?: 'default' | 'small' | 'large' | 'dense';
}

export const FlatAppbar: React.FC<FlatAppbarProps> = ({ children, variant = 'default' }) => (
    <Root>
        <div
            className={clsx(classes.marginBlock, {
                [classes.small]: variant === 'small',
                [classes.large]: variant === 'large',
                [classes.dense]: variant === 'dense'
            })}
        />
        <AppBar position="fixed" elevation={0} className={classes.appBar}>
            {children}
        </AppBar>
    </Root>
);
